define([
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/actions/SubscribersActions',
], (Immutable, _, Util, Actions) => {
  const initialState = Immutable.Map({
    campaign: Immutable.Map(),
    errors: Immutable.Map(),
    loading: false,
    sending: false,
    fetchedAt: 0,
    textFilter: '',
  });

  const actionHandlers = {};

  actionHandlers[Actions.RESET_CAMPAIGN_ERRORS] = state => state.set('errors', Immutable.Map());

  actionHandlers[Actions.REQUEST_CAMPAIGN] = state => state.set('sending', true);

  actionHandlers[Actions.RECEIVE_CAMPAIGN] = (state, action) => {
    let retState = state.set('sending', false);

    const campaign = Immutable.fromJS(action.campaign);

    retState = retState.set('campaign', campaign);
    retState = retState.deleteIn(['errors', 'fetch']);
    retState = retState.set('fetchedAt', Date.now());

    return retState;
  };

  actionHandlers[Actions.ERROR_CAMPAIGN] = (state, action) => {
    const code = action.code;
    const error = action.error;

    const retState = state.set('sending', false);

    return retState.mergeIn(['errors'], { [code]: `${error}` });
  };

  return Util.createReducer(initialState, actionHandlers);
});
